import { render, staticRenderFns } from "./AccountSettingsWrapper.vue?vue&type=template&id=2e1217a2&scoped=true"
import script from "./AccountSettingsWrapper.vue?vue&type=script&lang=ts"
export * from "./AccountSettingsWrapper.vue?vue&type=script&lang=ts"
import style0 from "./AccountSettingsWrapper.vue?vue&type=style&index=0&id=2e1217a2&prod&lang=scss&scoped=true"
import style1 from "./AccountSettingsWrapper.vue?vue&type=style&index=1&id=2e1217a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1217a2",
  null
  
)

export default component.exports